<template>
	<a-layout id="components-layout-demo-top" class="layout">
		<a-layout-header>
			 <a-row>
				<a-col :span="20">
			        <a-menu theme="dark" :selectedKeys="[index]" mode="horizontal" :style="{ lineHeight: '64px' }" @click="titleClick">
			        	<a-menu-item :disabled="level2 == 0"  key="1">
			        		<span v-if="level2 == 0">
			        			<a-tooltip placement="bottom">
			        				<template slot="title">
			        				  <span>您暂未开通企业名片，无法使用该功能！</span>
			        				</template>
			        				<a-icon type="shop" />
			        				企业商铺管理
			        			</a-tooltip>
			        		</span>
			        		<span v-else>
			        			<a-icon type="shop" />
			        			企业商铺管理
							</span>
			        	</a-menu-item>
			        	<a-menu-item :disabled="level3 == 0 && level4 == 0" key="2">
			        		<span v-if="level3 == 0 && level4 == 0">
			        			<a-tooltip placement="bottom">
			        				<template slot="title">	
			        				  <span>您暂未开通商会/协会名片，无法使用该功能！</span>
			        				</template>
			        				<a-icon type="usergroup-add" />
			        				商会/协会管理
			        			</a-tooltip>
			        		</span>
			        		<span v-else>
			        			<a-icon type="usergroup-add" />
			        			商会/协会管理
			        		</span>
			        		
			        		
			        	</a-menu-item>
					</a-menu>
				</a-col>
				<a-col :span="4">
					<div class="logo">
						<a-avatar v-if="avatar == ''" size="large" icon="user" />
						<a-avatar v-else size="large" :src="avatar" />
						<a-popover title="账号" trigger="click" v-model="visible">
							<a @click="exitLogin" slot="content">退出登录</a>
							<a-button type="link" icon="caret-down" ghost>{{username}}</a-button>
						</a-popover>
					</div>
				</a-col>
			</a-row>
			
		</a-layout-header>
		<a-layout>
			<a-layout-sider width="200" v-show="index != '3'" style="background: #fff;margin-top: 20px;">
				<a-menu mode="inline" :default-selected-keys="['1']" :default-open-keys="['sub1']" :style="{ height: '100%', borderRight: 0 }">
					<StoreMenu @StoreMenuClick="getStoreMenu" v-if="index == '1'"></StoreMenu>
					<BusinessClubMenu @BusinessClubMenuClick="getBusinessClubMenu" v-if="index == '2'"></BusinessClubMenu>
				</a-menu>
			</a-layout-sider>
			<a-layout style="padding: 0 24px 24px">
				<a-breadcrumb style="margin: 16px 0">
					<a-breadcrumb-item>{{home}}</a-breadcrumb-item>
					<a-breadcrumb-item v-if="list != ''">{{list}}</a-breadcrumb-item>
					<a-breadcrumb-item v-if="app != ''">{{app}}</a-breadcrumb-item>
				</a-breadcrumb>
				<a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '680px' }">
					<CustomerService v-if="list == '店铺客服'"></CustomerService>
					<StoreHome v-else-if="list == '工厂信息'"></StoreHome>
					<ProductEvaluate v-else-if="list == '用户评价'"></ProductEvaluate>
					<CompanyStyle v-else-if="list == '公司风采'"></CompanyStyle>
					<Index v-else-if="list == '经营数据'"></Index>
					<BCustomerService v-else-if="list == '商会客服'"></BCustomerService>
					<BusinessArea v-else-if="list == '商会分类标签'"></BusinessArea>
					<Honour v-else-if="list == '商会荣耀'"></Honour>
					<Industrys v-else-if="list == '商会行业设置'"></Industrys>
					<Help v-else-if="list == '创业互助'"></Help>
					<FinancialPublic v-else-if="list == '财务公示'"></FinancialPublic>
					<RefundOrder v-else-if="list == '退货申请处理'"></RefundOrder>
					<AddCommodity v-else-if="app == '添加商品'"></AddCommodity>
					<CommodityList v-else-if="app == '商品管理'"></CommodityList>
					<ProductAttr v-else-if="app == '商品分类'"></ProductAttr>
					<orderList v-else-if="app == '订单列表'"></orderList>
					<Inform v-else-if="app == '商会公告'"></Inform>
					<Dynamic v-else-if="app == '商会动态'"></Dynamic>
					<Member v-else-if="app == '商会成员'"></Member>
					<BusinessHome v-else-if="app == '商会简介'"></BusinessHome>
					<CommodityAttr v-else-if="app == '商城分类'"></CommodityAttr>
					<!-- <ProductList v-else-if="app == '商品列表'"></ProductList> -->
					<Advertising v-else-if="app == '广告列表'"></Advertising>
					<div v-else> <a-empty description="暂无数据" /></div>
				</a-layout-content>
			</a-layout>
		</a-layout>
		<a-layout-footer style="text-align: center">帝全网络 ©2019 帝全网络商铺管理后台 </a-layout-footer>
	</a-layout>
</template>
<script>
	//侧边栏
import StoreMenu from '../components/StoreMenu.vue';
import BusinessClubMenu from '../components/BusinessClubMenu.vue';
	//页面
	
import Index from '../components/store/index.vue'; //经营数据
import CustomerService from '../components/store/CustomerService.vue'; //店铺客服
import StoreHome from '../components/store/StoreHome.vue'; //工厂信息
import AddCommodity from '../components/store/commodity/AddCommodity.vue'; //添加商品
import CommodityList from '../components/store/commodity/CommodityList.vue'; //商品管理
import ProductAttr from '../components/store/productAttr.vue'; //商品分类
import CompanyStyle from '../components/store/CompanyStyle.vue'; //公司风采

import ProductEvaluate from '../components/store/ProductEvaluate.vue'; //评论
import Advertising from '../components/store/marketing/Advertising.vue'; //广告列表

import orderList from '../components/store/order/orderList.vue'; // 订单列表
import orderDetail from '../components/store/order/orderDetail.vue'; // 订单详情
import RefundOrder from '../components/store/order/refundOrder.vue'; // 订单列表



import BCustomerService from '../components/business/CustomerService.vue'; //商会客服
import Inform from '../components/business/Inform.vue'; //商会公告
import Dynamic from '../components/business/Dynamic.vue'; //商会动态
import Member from '../components/business/Member.vue'; //商会成员
import BusinessHome from '../components/business/BusinessHome.vue'; //商会经营数据
import BusinessArea from '../components/business/BusinessArea.vue'; //商会区域设置
import Industrys from '../components/business/Industrys.vue'; //商会行业设置
import Honour from '../components/business/honour.vue'; //商会荣耀
import Help from '../components/business/helpBusiness.vue'; //商会创业互助
import FinancialPublic from '../components/business/financialPublic.vue'; //商会财务公示
import CommodityAttr from '../components/business/commerceStore/commodityAttr.vue'; //商会商铺类型
import ProductList from '../components/business/commerceStore/commerceProductList.vue'; //商会商品管理

import axios from 'axios';
import api from '../api/Api.js'

export default {
	components: {
		StoreMenu,
		BusinessClubMenu,
		CustomerService,
		StoreHome,
		AddCommodity,
		ProductAttr,
		CompanyStyle,
		BCustomerService,
		Inform,
		Dynamic,
		Member,
		BusinessHome,
		BusinessArea,
		Industrys,
		CommodityList,
		orderList,
		orderDetail,
		Honour,
		Help,
		FinancialPublic,
		CommodityAttr,
		ProductList,
		RefundOrder,
		ProductEvaluate,
		Advertising,
		Index
	},
	data() {
		return {
			home: 'home',
			list: 'list',
			app: '',
			index: '1',
			visible: false,
			username:'用户',
			avatar: '',
			token:'',
			level2: localStorage.getItem('level2'),
			level3: localStorage.getItem('level3'),
			level4: localStorage.getItem('level4'),
			openkey: '1'
		};
	},
	mounted() {
		this.username = localStorage.getItem('username')
		this.avatar = localStorage.getItem('avatar')
		
		const level2 = localStorage.getItem('level2');
		
		if(level2 == 1){
			this.home = "商铺管理";
			this.list = "经营数据";
			this.index = '1';
		}else{
			this.home = "商会管理";
			this.list = "商会管理";
			this.app = "商会简介";
			this.index = '2';
			console.log("==========================");
			console.log("==========================");
		}
		
	},
	methods: {
		titleClick(item, key, keyPath) {
			this.index = item.key;
			if(this.index == '2'){
				if(this.home != "商会管理"){
					this.list = "商会管理";
					this.app = "商会简介";
				}
				this.home = "商会管理";
			}
		},
		getStoreMenu(val) {
			this.Content = val
			this.home = "企业商铺管理";
			if(val == '商品管理'){
				this.list = "商铺管理";
				this.app = val;
			}else if(val == '添加商品'){
				this.list = "商铺管理";
				this.app = val;
			}else if(val == '商品分类'){
				this.list = "商铺管理";
				this.app = val;
			}else if(val == '订单列表'){
				this.list = "订单管理";
				this.app = val;
			}else if(val == '广告列表'){
				this.list = "营销管理";
				this.app = val;
			}else{
				this.list = val;
				this.app = ""
			}
		},
		getBusinessClubMenu(val){
			this.Content = val
			this.home = " 商会/协会管理";
			if(val == '商城分类'){
				this.list = "商会商城";
				this.app = val;
			}else if(val == '商品列表'){
				this.list = "商会商城";
				this.app = val;
			}else if(val == '商会公告'){
				this.list = "商会管理";
				this.app = val;
			}else if(val == '商会动态'){
				this.list = "商会管理";
				this.app = val;
			}else if(val == '商会成员'){
				this.list = "商会管理";
				this.app = val;
			}else if(val == '商会简介'){
				this.list = "商会管理";
				this.app = val;
			}else{
				this.list = val;
				this.app = ""
			}
			
			
		},
		exitLogin() {
			// let url = 'api/login/v1/logout/logout';
			// let param = 1;
			// api.postRequest(url, param, res => {});
			localStorage.removeItem('accessToken')
			localStorage.removeItem('Flag')
			localStorage.removeItem('username');
			localStorage.removeItem('avatar');
			localStorage.removeItem('accountId');
			localStorage.removeItem('level2');
			localStorage.removeItem('level3');
			localStorage.removeItem('level4');
			localStorage.removeItem('phone');
			
			this.visible = false;
			this.$message.error("退出成功")
			const that = this;
			//登录成功后跳转到指定页面
			this.$router.push("/");
		},
	}
};
</script>
<style>
#components-layout-demo-top .logo {
	width: 300px;
	height: 31px;
	color: #fff;
	float: left;
	font-size: 20px;
}
</style>
